// extracted by mini-css-extract-plugin
export default {"container":"footer_container__WeoWP","title_col":"footer_title_col__401Dg","message":"footer_message__DdBMr","line":"footer_line__7J50Z"};